// React
import React, { useEffect, useState } from "react";

// MUI
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Collapse,
  Autocomplete,
  Paper,
  Tooltip,
  Checkbox,
  CircularProgress,
} from "@mui/material";

//MUI ICON
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";

// Formik
import { useFormik } from "formik";
import * as Yup from "yup";

//Components
import Dropzone from "components/Dropzone_one";
import {
  GradientButton,
  GradientButtonOutline,
  GradientShadow,
} from "components/GradientButton";
import Form from "components/Form/FormReturnOfAssets";

// API
import api from "_api";

// Other
import { Divider } from "antd";
import Swal from "sweetalert2";
import ReactDOM from "react-dom";
import SaveIcon from "assets/images/SaveIcon.svg";
import { CheckCircle } from "@mui/icons-material";

// ฟังก์ชันสำหรับสร้าง validation schema ให้กับฟอร์ม
const validationSchema = Yup.object({
  // payment_channel: Yup.string().required("โปรดระบุช่องทางการชำระ"),
  notes_condition: Yup.string().required("โปรดระบุหมายเหตุ"),
});

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field ของผู้ที่มาซื้อ
const customerFields = [
  {
    label: "ชื่อ-นามสกุล",
    name: "fullName",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "เลขบัตรประชาชน",
    name: "idCardNumber",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "phoneNumber",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "ที่อยู่",
    name: "address",
    type: "text",
    // required: true,
    disabled: true,
  },
];

const conditionPawn = [
  {
    label: "ช่องทางการชำระ",
    name: "payment_channel",
    type: "autocomplete",
    required: true,
    // width: "90%",
    // specialText: "เดือน",
  },
  {
    label: "หมายเหตุ",
    name: "notes_condition",
    type: "text",
    required: true,
  },
];

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field หมวดหมู่
const categoryOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];

const payment_channelOptions = [
  { label: "เงินสด", id: "เงินสด" },
  { label: "เงินโอน", id: "โอนผ่านธนาคาร" },
  { label: "เช็ค", id: "เช็ค" },
  { label: "บัตรเครดิต", id: "บัตรเครดิต" },
];

const ModalReturn = ({ open, onClose, selectedProduct, fetchProductData }) => {
  // ตัวแปรสำหรับเก็บข้อมูลรูปภาพ
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const [proofOfPayment, setProofOfPayment] = useState([]);

  // ตัวแปรสำหรับเก็บข้อของ Box แสดง Product
  const [productBoxes, setProductBoxes] = useState([
    { id: 1, isExpanded: false },
  ]);
  const [expandedRow, setExpandedRow] = useState(null); // เก็บการแสดงผลของ Row ในการ Explaned
  const [statusSave, setStatusSave] = useState(false); // เก็บ status หลังจากมีการเพิ่ม Box
  const [currentStep, setCurrentStep] = useState(1); // Track the current step
  // const [selectedOption, setSelectedOption] = useState(1); // For selecting the display count option
  const [isHovered, setIsHovered] = useState(false);
  const [activeButton, setActiveButton] = useState("pawnContract");
  const [sumTotalPrice, setSumTotalPrice] = useState(0);

  //เก็บตัวแปร id หลังจากสร้าง product เสร็จ
  const [newIds, setNewIds] = useState([
    {
      product_id: 0,
      amount: 0,
      total_price: 0,
    },
  ]);

  // keep data order when create order success
  const [order, setOrder] = useState(null);

  // loading and status success when create order
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  //กรณีมีการส่งข้อมูลเข้ามาจะแสดง
  useEffect(() => {
    if (selectedProduct) {
      console.log("selectedProduct", selectedProduct);
      setExpandedBoxes(selectedProduct?.order_borrows[0].id);
      // ตรวจสอบว่า order_borrows มีข้อมูล และเป็นอาร์เรย์
      if (
        selectedProduct?.order_borrows &&
        Array.isArray(selectedProduct.order_borrows)
      ) {
        const formikValues = {};

        selectedProduct.order_borrows.forEach((pawn) => {
          console.log("pawn", pawn);
          const id = pawn.id; // ใช้ `id` แยกฟิลด์แต่ละ box
          const category_id = pawn.category_id;

          // เพิ่มฟิลด์สำหรับแต่ละ box
          formikValues[`product_code_${id}`] = pawn.product_code || "";
          formikValues[`product_name_${id}`] = pawn.product_name || "";
          formikValues[`category_id_${id}`] =
            categoryOptions.find((category) => category.id === category_id) ||
            null;
          formikValues[`detail_${id}`] = pawn.detail || "";
          formikValues[`blemishes_${id}`] = pawn.blemishes || "";
          formikValues[`size_${id}`] = pawn.size || "";
          formikValues[`total_amount_${id}`] = pawn.pawn_amount || 1;
          formikValues[`price_${id}`] = pawn.product_price || 0;
          formikValues[`total_price_${id}`] = pawn.pawn_price || 0;
          formikValues[`price_borrow_${id}`] = pawn.price || 0;
          formikValues[`borrow_amount_${id}`] = pawn.lenting_amount || 0;
          // เก็บรูปภาพในฟิลด์ `images_${id}`
          formikValues[`images_${id}`] = Array.isArray(pawn.pictures)
            ? pawn.pictures.flatMap((picObj) =>
                Array.isArray(picObj.picture) ? picObj.picture : []
              )
            : [];

          pawn?.slip_pictures?.forEach((picObj) => {
            setInitialProductUrls([...initialProductUrls, {
              picture: picObj.picture[0],
              id: picObj.id,
            }]);
          });


          //เงื่อนไขการยืม
          switch (pawn.payment_channel) {
            case "เงินสด":
              formikValues.payment_channel = { label: "เงินสด", id: "เงินสด" };
              break;
            case "โอนผ่านธนาคาร":
              formikValues.payment_channel = {
                label: "เงินโอน",
                id: "โอนผ่านธนาคาร",
              };
              break;
            case "เช็ค":
              formikValues.payment_channel = { label: "เช็ค", id: "เช็ค" };
              break;
            case "บัตรเครดิต":
              formikValues.payment_channel = {
                label: "บัตรเครดิต",
                id: "บัตรเครดิต",
              };
              break;
            default:
              formikValues.payment_channel = pawn.payment_channel
                ? { label: pawn.payment_channel, id: pawn.payment_channel }
                : "";
              break;
          }

          // formikValues.payment_channel = pawn.payment_channel || "";
          formikValues.total_price_order = selectedProduct.total_price || "";
          formikValues.penalty = pawn.penalty || 0;
          formikValues.return_date = pawn.return_date || 0;
          formikValues.slip_pictures = selectedProduct.slip_pictures || 0;
        });

        // เพิ่มข้อมูลลูกค้า
        formikValues.fullName = selectedProduct.customer_name || "";
        formikValues.idCardNumber = selectedProduct.idcard || "";
        formikValues.phoneNumber = selectedProduct.phonenumber || "";
        formikValues.address = selectedProduct.address || "";
        formikValues.product_images = selectedProduct.picture || [];
        formikValues.late_fees = selectedProduct.late_fees || 0;

        formikValues.total_price_order = selectedProduct.total_price || 0;
        formikValues.created_date = selectedProduct.created_date || 0;

        // ตั้งค่า Formik values
        formik.setValues(formikValues);
      }
    }
  }, [selectedProduct]);

  //ฟังก์ชันแสดง Explanded
  const handleExpandClick = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  //ฟังก์ชันลบ Box
  const handleDeleteBox = (rowId) => {
    if (productBoxes.length > 1) {
      setProductBoxes((prevBoxes) =>
        prevBoxes.filter((box) => box.id !== rowId)
      );
    } else {
      alert("Cannot delete the last remaining box.");
    }
  };

  //ฟังก์ชันเปลี่ยนหน้า
  const handleNextStep = () => {
    setCurrentStep(currentStep + 1); // Go to the next "page"
  };

  //ฟังก์ชันสำหรับการเปลี่ยนหน้าแสดงผลใน Modal
  const handleBackToStep1 = () => {
    setCurrentStep(1); // Reset back to the first step if needed
  };

  // ฟังก์ชันเพิ่ม product box
  const addProductBox = () => {
    if (productBoxes.length < 15) {
      setProductBoxes([
        ...productBoxes,
        { id: productBoxes.length + 1, isExpanded: false },
      ]);
      setStatusSave(false);
    } else {
      alert("คุณสามารถเพิ่มสินค้าได้สูงสุด 15 รายการเท่านั้น");
    }
  };

  // ฟังก์ชัน explan
  const toggleExpand = (id) => {
    setExpandedBoxes((prevId) => (prevId === id ? null : id)); // หาก id ซ้ำให้ปิด, หากต่างให้เปิด
  };
  // สร้างรหัสตัวแปรตามจำนวน Box ที่เพิ่ม
  const generateInitialValues = (selectedProduct) =>
    productBoxes.reduce(
      (values, { id }) => ({
        ...values,
        [`product_id_${id}`]: "",
        [`product_code_${id}`]: "",
        [`product_code_com_${id}`]: "",
        [`product_name_${id}`]: "",
        [`category_id_${id}`]: "",
        [`detail_${id}`]: "",
        [`blemishes_${id}`]: "",
        [`size_${id}`]: "",
        [`total_amount_${id}`]: "",
        [`price_${id}`]: "",
        [`total_price_${id}`]: "",
        [`notes_${id}`]: "",
        [`images_${id}`]: [],
      }),
      {}
    );

  // นับจำนวน Box
  // const productBoxCount = productBoxes.length;

  // console.log("display new id in array", productBoxes);

  // Function to convert object to FormData
  const transformObjectToFormData = (obj) => {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      if (key === "category_id" && value?.id) {
        formData.append(key, value.id);
      } else if (key === "period" && Array.isArray(value)) {
        // แปลง period เป็น JSON string ก่อน
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, JSON.stringify(item));
        });
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, item);
        });
      } else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    return formData;
  };

  // Formik hook
  const formik = useFormik({
    initialValues: {
      penalty: "",
      file: "",
    },
    // validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        console.log("Submitting values:", selectedProduct.id);

        if (!selectedProduct || !selectedProduct.id) {
          alert("ไม่มีข้อมูลสินค้า กรุณาเลือกสินค้า");
          return;
        }

        // สร้าง orderDataArray จาก selectedTransactions
        const orderData = {
          id: selectedProduct.id,
          penalty: values.penalty, // Make sure 'penalty' is defined somewhere in your component
          file: files1.map((fileObj) => fileObj.file), // Make sure 'files1' is defined
        };

        // console.log("Order Data:", orderData);

        // แปลงข้อมูลเป็น FormData และส่งไปยัง API
        const formData = transformObjectToFormData(orderData);

        console.log("FormData Entries:", Array.from(formData.entries()));

        const orderResponse = await api.pawn.changeToReturnOrder(formData);

        if (!orderResponse.isStatus) {
          console.error("Error creating order:", orderResponse);
          alert("Error creating order. Please try again.");
          return;
        }

        // สร้าง order สำเร็จ
        setOrder(orderResponse.data);

        setTimeout(() => {
          setIsSuccess(true);
          setLoading(false);
        }, 1000);

        // alert("Order submitted successfully.");
      } catch (error) {
        setLoading(false);
        console.error("Error submitting form:", error);
        alert("An error occurred. Please try again.");
      }
    },
  });

  const mapSelectedProductToField = (selectedProduct, fieldName) => {
    const mapping = {
      fullName: selectedProduct.customer_name,
      idCardNumber: selectedProduct.idcard,
      phoneNumber: selectedProduct.phonenumber,
      address: selectedProduct.address,
    };

    return mapping[fieldName];
  };

  const handlePrintPDF = async () => {
    if (order) {
      await api.product
        .getPrintPdfReturnOrder(order?.createOrderLog?.order_id)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/pdf" })
          );
          window.open(url, "_blank");
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const handleClose = () => {
    onClose();
    setProductBoxes([{ id: 1, isExpanded: false }]);
    setFiles1([]);
    setFiles2([]);
    setIsSuccess(false);
    setLoading(false);
    setCurrentStep(1);
    formik.resetForm();
    fetchProductData();
  };

  // ฟังก์ชันลบรูป
  const handleImageDelete = (boxId, imageIndex) => {
    const currentImages = formik.values[`images_${boxId}`] || [];

    // Safeguard against undefined or null images array
    const updatedImages = currentImages.filter(
      (_, index) => index !== imageIndex
    );

    formik.setFieldValue(`images_${boxId}`, updatedImages);
  };

  // console.log("selectedProduct", selectedProduct);

  useEffect(() => {
    let totalSum = 0;

    productBoxes.forEach((box) => {
      const totalAmount = formik.values[`total_amount_${box.id}`];
      const price = formik.values[`price_${box.id}`];
      const totalAmountLenting = formik.values[`total_amount_borrow_${box.id}`];
      const priceBorrow = formik.values[`price_borrow_${box.id}`];

      if (totalAmount && price) {
        const totalPrice = Number(totalAmount) * Number(price);
        formik.setFieldValue(`total_price_${box.id}`, totalPrice);
      }

      if (totalAmountLenting && priceBorrow) {
        const totalPrice = Number(totalAmountLenting) * Number(priceBorrow);
        totalSum += totalPrice; // รวม total_price
      }
    });

    // เก็บผลรวมใน sumTotalPrice
    setSumTotalPrice(totalSum);
  }, [formik.values, formik.setFieldValue, productBoxes]);

  // ฟังก์ชันการแสดงฟิลด์ Checkbox

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFields = (fields, selectedProduct) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>

            {field.type === "autocomplete" ? (
              <Autocomplete
                id={field.name}
                options={categoryOptions}
                getOptionLabel={(option) => option.label}
                value={formik.values.category_id}
                onChange={(event, newValue) => {
                  if (!field.disabled) {
                    formik.setFieldValue("category_id", newValue);
                  }
                }}
                disabled={field.disabled}
                fullWidth
                sx={{
                  flexGrow: 1,
                  ".MuiAutocomplete-inputRoot": {
                    height: "40px",
                    padding: "0px !important", // Ensure consistent padding
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name={field.name}
                    error={
                      formik.touched[field.name] &&
                      Boolean(formik.errors[field.name])
                    }
                    helperText={
                      formik.touched[field.name] && formik.errors[field.name]
                    }
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                )}
              />
            ) : (
              <TextField
                disabled={field.disabled}
                id={field.name}
                name={field.name}
                type={field.type}
                value={
                  selectedProduct
                    ? mapSelectedProductToField(selectedProduct, field.name)
                    : ""
                }
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched[field.name] &&
                  Boolean(formik.errors[field.name])
                }
                helperText={
                  formik.touched[field.name] && formik.errors[field.name]
                }
                fullWidth
                InputProps={{ sx: { height: "40px", padding: "0px" } }} // Ensure consistent height
              />
            )}
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  const showData = () => {
    return console.log("ก็เข้านะ");
  };

  const [expandedBoxes, setExpandedBoxes] = useState();

  // ฟังก์ชันการแสดงฟิลด์ของ Product
  const renderProductBoxes = () => {
    return selectedProduct?.order_borrows.map((box) => (
      <Box
        key={box.id}
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center" // Add this to center items vertically
          onClick={() => toggleExpand(box.id)}
        >
          <Typography variant="subtitle1">{box.product_name}</Typography>
          <div>
            <IconButton
              disabled={productBoxes.length > 1 ? false : true}
              size="small"
              color="#ccc"
              onClick={(e) => {
                e.stopPropagation(); // Prevent toggleExpand from triggering on delete click
                handleDeleteBox(box.id); // Call the delete function
              }}
            >
              {/* <DeleteIcon /> */}
            </IconButton>
            <IconButton
              size="small"
              color="#ccc"
              onClick={() => handleExpandClick(box.id)}
              style={{
                transform: expandedRow === box.id ? "rotate(180deg)" : "none",
                transition: "transform 0.2s ease-in-out",
                marginLeft: "10px",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </div>
        </Box>
        <Collapse in={expandedBoxes === box.id}>
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Divider sx={{ borderColor: "#00BB9F", borderWidth: 1 }} />

            {/* Product Code Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>รหัสสินค้า {""}</Typography>
                    {/* <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                      <InfoIcon style={{ color: "#e5e5e5", marginRight: 10 }} />
                    </Tooltip> */}
                  </div>
                </Grid>

                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`product_code_${box.id}`} // ใช้ id เพื่อแยกชื่อ
                    value={formik.values[`product_code_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    error={
                      formik.touched[`product_code_${box.id}`] &&
                      Boolean(formik.errors[`product_code_${box.id}`])
                    }
                    helperText={
                      formik.touched[`product_code_${box.id}`] &&
                      formik.errors[`product_code_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Product Code2 Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>รหัส 2 {""}</Typography>
                    <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                      <InfoIcon style={{ color: "#e5e5e5", marginRight: 10 }} />
                    </Tooltip>
                  </div>
                </Grid>

                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`product_code_com_${box.id}`} // ใช้ id เพื่อแยกชื่อ
                    value={formik.values[`product_code_com_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    error={
                      formik.touched[`product_code_com_${box.id}`] &&
                      Boolean(formik.errors[`product_code_com_${box.id}`])
                    }
                    helperText={
                      formik.touched[`product_code_com_${box.id}`] &&
                      formik.errors[`product_code_com_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Name Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ชื่อสินค้า{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`product_name_${box.id}`}
                    value={formik.values[`product_name_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    error={
                      formik.touched[`product_name_${box.id}`] &&
                      Boolean(formik.errors[`product_name_${box.id}`])
                    }
                    helperText={
                      formik.touched[`product_name_${box.id}`] &&
                      formik.errors[`product_name_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Category Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    หมวดหมู่{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Autocomplete
                    disabled
                    id={`category_id_${box.id}`}
                    options={categoryOptions}
                    getOptionLabel={(option) => option.label || ""} // ใช้ label เพื่อแสดงชื่อ category
                    value={
                      // ตรวจสอบว่าค่าที่ตั้งอยู่ใน formik.values มี id ตรงกับตัวเลือกใน categoryOptions หรือไม่
                      categoryOptions.find(
                        (option) =>
                          option.id ===
                          formik.values[`category_id_${box.id}`]?.id
                      ) || null // หากไม่พบ ให้ส่ง null ไป
                    }
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        `category_id_${box.id}`,
                        newValue?.id || "" // เก็บเฉพาะ id ใน Formik
                      );
                    }}
                    fullWidth
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        height: "40px", // กำหนดความสูงให้เท่ากัน
                        padding: "0 8px", // เพิ่ม padding เล็กน้อย
                      },
                      ".MuiOutlinedInput-root": {
                        height: "40px", // กำหนดความสูงให้สม่ำเสมอใน wrapper
                      },
                      ".MuiAutocomplete-input": {
                        padding: "0px", // กำหนด padding ให้น้อยลง
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        {...params}
                        name={`category_id_${box.id}`} // ใช้ name ที่ถูกต้องในการตรวจสอบ validation
                        error={
                          formik.touched[`category_id_${box.id}`] &&
                          Boolean(formik.errors[`category_id_${box.id}`])
                        }
                        helperText={
                          formik.touched[`category_id_${box.id}`] &&
                          formik.errors[`category_id_${box.id}`]
                        }
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          sx: { height: "40px", padding: "0px" }, // กำหนดความสูงให้สม่ำเสมอ
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Detail Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>รายละเอียด</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`detail_${box.id}`}
                    value={formik.values[`detail_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`detail_${box.id}`] &&
                      Boolean(formik.errors[`detail_${box.id}`])
                    }
                    helperText={
                      formik.touched[`detail_${box.id}`] &&
                      formik.errors[`detail_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Blemishes Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>ตำหนิ</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`blemishes_${box.id}`}
                    value={formik.values[`blemishes_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`blemishes_${box.id}`] &&
                      Boolean(formik.errors[`blemishes_${box.id}`])
                    }
                    helperText={
                      formik.touched[`blemishes_${box.id}`] &&
                      formik.errors[`blemishes_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Size Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>ขนาด</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`size_${box.id}`}
                    value={formik.values[`size_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`size_${box.id}`] &&
                      Boolean(formik.errors[`size_${box.id}`])
                    }
                    helperText={
                      formik.touched[`size_${box.id}`] &&
                      formik.errors[`size_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Total amount Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    จำนวน{" "}
                    {/* <span style={{ color: "red", marginLeft: "3px" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`total_amount_${box.id}`}
                    value={formik.values[`total_amount_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`total_amount_${box.id}`] &&
                      Boolean(formik.errors[`total_amount_${box.id}`])
                    }
                    helperText={
                      formik.touched[`total_amount_${box.id}`] &&
                      formik.errors[`total_amount_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Price Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ราคาทุน{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`price_${box.id}`}
                    value={formik.values[`price_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`price_${box.id}`] &&
                      Boolean(formik.errors[`price_${box.id}`])
                    }
                    helperText={
                      formik.touched[`price_${box.id}`] &&
                      formik.errors[`price_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Total Price Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ราคารวม{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`total_price_${box.id}`}
                    value={formik.values[`total_price_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`total_price_${box.id}`] &&
                      Boolean(formik.errors[`total_price_${box.id}`])
                    }
                    helperText={
                      formik.touched[`total_price_${box.id}`] &&
                      formik.errors[`total_price_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Notes Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>หมายเหตุ</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`notes_${box.id}`}
                    value={formik.values[`notes_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`notes_${box.id}`] &&
                      Boolean(formik.errors[`notes_${box.id}`])
                    }
                    helperText={
                      formik.touched[`notes_${box.id}`] &&
                      formik.errors[`notes_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Image Row */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 2 }}>
                รูปทรัพย์
              </Typography>
              <Grid item xs={12}>
                <div>
                  {Array.isArray(formik.values[`images_${box.id}`]) &&
                  formik.values[`images_${box.id}`].length > 0 ? (
                    <div>
                      {/* แสดงภาพ */}
                      {formik.values[`images_${box.id}`].map(
                        (imageUrl, index) => (
                          <img
                            key={index}
                            src={imageUrl}
                            alt={`Image ${index + 1} for Box ${box.id}`}
                            style={{
                              width: "150px",
                              height: "150px",
                              objectFit: "cover",
                              marginRight: "10px",
                            }}
                          />
                        )
                      )}
                    </div>
                  ) : (
                    <p>No images available for Box {box.id}</p>
                  )}
                </div>
              </Grid>

              {error1 && (
                <Typography variant="caption" color="error">
                  {error1}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Collapse>
      </Box>
    ));
  };

  const extractDate = (dateTimeString) => {
    if (!dateTimeString) return "";
    const [datePart] = dateTimeString.split(" เวลา");
    return datePart.trim(); // คืนค่าเฉพาะส่วนวันที่
  };

  const renderFieldsPayment = () => {
    return (
      <Box
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid container spacing={2}>
          {/* Product Payment Channel Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ช่องทางการชำระ{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  disabled
                  id={`payment_channel`}
                  options={payment_channelOptions}
                  getOptionLabel={(option) => option.label}
                  value={formik.values.payment_channel || ""}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(`payment_channel`, newValue);
                  }}
                  sx={{
                    ".MuiAutocomplete-inputRoot": {
                      height: "40px",
                      padding: "0px 0px 0px 5px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name={`payment_channel`}
                      error={
                        formik.touched.payment_channel &&
                        Boolean(formik.errors.payment_channel)
                      }
                      helperText={
                        formik.touched.payment_channel &&
                        formik.errors.payment_channel
                      }
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        sx: { height: "40px" },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Slip Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  หลักฐานการชำระเงิน{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                {initialProductUrls.map((url, index) => (
                  <img
                    key={index}
                    src={url.picture}
                    alt={`Product ${index}`}
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      marginRight: "10px",
                    }}
                  />
                ))}
              </Grid>
            </Grid>
          </Grid>

          {/* Product Amount Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  กำหนดคืน
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  disabled
                  fullWidth
                  name="return_date"
                  value={extractDate(formik.values.return_date)}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.return_date &&
                    Boolean(formik.errors.return_date)
                  }
                  helperText={
                    formik.touched.return_date && formik.errors.return_date
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Total Price Order Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>ราคารวม{""}</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  disabled
                  fullWidth
                  name={`total_price_order`}
                  value={formik.values.total_price_order || sumTotalPrice || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.total_price_order &&
                    Boolean(formik.errors.total_price_order)
                  }
                  helperText={
                    formik.touched.total_price_order &&
                    formik.errors.total_price_order
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Notes Order Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  หมายเหตุ{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  disabled
                  fullWidth
                  name={`notes_order`}
                  value={formik.values.notes_order || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.notes_order &&
                    Boolean(formik.errors.notes_order)
                  }
                  helperText={
                    formik.touched.notes_order && formik.errors.notes_order
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  };

  // console.log("display formik.values", formik.values);
  //กรณีปิดหน้าต่าง Modal
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <!-- Left side icon/picture -->
            <div style="margin-right: 20px;">
              <img src="${SaveIcon}" alt="warning icon" width="300" height="300"/>
            </div>
      
            <!-- Right side text and buttons -->
            <div style="flex: 1;">
              <h2 style="font-size: 24px; color: #333;">ยืนยันการบันทึกหรือไม่</h2>
              <div id="custom-buttons" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <!-- React buttons will be injected here -->
              </div>
            </div>
          </div>
        `,
        showCancelButton: false, // Disable default buttons
        showConfirmButton: false, // Disable default buttons
        customClass: {
          container: "swal2-container-custom",
        },
        didOpen: () => {
          document.querySelector(".swal2-container-custom").style.zIndex = 1500;

          // Render your React button components after the Swal modal opens
          ReactDOM.render(
            <>
              <GradientButton
                onClick={() => {
                  // Handle cancel behavior
                  Swal.close(); // Close Swal
                }}
                style={{ width: "100%", marginBottom: "10px" }} // Make full width
              >
                ยกเลิก
              </GradientButton>
              <GradientButtonOutline
                onClick={() => {
                  // Close the current Swal first before showing the confirmation Swal
                  Swal.close();
                  formik.resetForm();
                  setFiles1([]); // Clear product images
                  setFiles2([]); // Clear customer images
                  setInitialProductUrls([]); // Clear initial product image URLs
                  // setInitialCustomerUrls([]);
                  setDeletedImageIds([]);
                  onClose();
                  setNewIds([]);
                }}
                style={{ width: "100%" }}
              >
                ตกลง
              </GradientButtonOutline>
            </>,
            document.getElementById("custom-buttons") // Inject React components into this div
          );
        },
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
      setNewIds([]);
    }
  };

  // Function to handle button click
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName); // Set the clicked button as active
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  // console.log("display formik naja", formik.values);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        //ป้องกันการกดเบื้องหลังแล้วหลุด
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      sx={{
        borderRadius: "8px",
      }}
    >
      {currentStep === 1 ? (
        <>
          {/* หน้าที่ 1 : Form */}
          <DialogTitle style={{ backgroundColor: "#F1F2F7" }}>
            <Typography variant="h4">คืนสินค้า</Typography>
          </DialogTitle>
          <DialogContent style={{ backgroundColor: "#F1F2F7" }}>
            <form onSubmit={formik.handleSubmit}>
              {/* Render the product boxes */}
              <Grid item xs={12} sx={{ mx: 2 }}>
                <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                  ข้อมูลลูกค้า
                </Typography>
                <Paper sx={{ p: 2, borderRadius: "12px" }}>
                  <Grid container>
                    <Grid item xs={7}>
                      {renderFields(customerFields, selectedProduct)}
                    </Grid>
                    <Grid item xs={5} sx={{ mt: 2 }}>
                      {selectedProduct ? (
                        <img
                          src={selectedProduct.customer_image}
                          alt="Preview"
                          style={{
                            width: "200px",
                            height: "200px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <Dropzone
                          files={files2}
                          setFiles={setFiles2}
                          setError={setError2}
                        />
                      )}
                      {error2 && (
                        <Typography variant="caption" color="error">
                          {error2}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Paper>

                <Grid items xs={12}>
                  {/* Render the product boxes */}
                  <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                    ข้อมูลสินค้า
                  </Typography>
                  {renderProductBoxes()}
                </Grid>

                <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                  เงื่อนไขการยืม
                </Typography>
                {renderFieldsPayment()}
                <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                  ค่าปรับ
                </Typography>
                <Paper sx={{ p: 2, borderRadius: "12px" }}>
                  <Grid container>
                    {/* Product Amount Row */}
                    <Grid item xs={12}>
                      <Grid container alignItems="center">
                        <Grid item xs={2}>
                          <Typography>
                            ค่าปรับ
                            <span style={{ marginLeft: "4px", color: "red" }}>
                              *
                            </span>
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <TextField
                            fullWidth
                            name="penalty"
                            value={formik.values.penalty}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.penalty &&
                              Boolean(formik.errors.penalty)
                            }
                            helperText={
                              formik.touched.penalty && formik.errors.penalty
                            }
                            InputProps={{
                              sx: { height: "40px", padding: "0px" },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      {/* Product Slip Row */}
                      <Box sx={{ mt: 2 }}>
                        <Typography>
                          หลักฐานการชำระเงิน{""}
                          <span style={{ marginLeft: "4px", color: "red" }}>
                            *
                          </span>
                        </Typography>
                        <Dropzone
                          files={files1}
                          setFiles={setFiles1}
                          setError={setError1}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </form>
          </DialogContent>

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{
                    borderRadius: "12px", // Make the button circular
                    minWidth: "40px", // Adjust the width
                    minHeight: "40px", // Adjust the height
                    padding: 0, // Remove padding to center the icon better
                    borderColor: "#c4c4c4", // Light grey border
                    color: "#6c6c6c", // Light grey icon color
                    display: "flex", // Ensure flexbox is used
                    alignItems: "center", // Center vertically
                    justifyContent: "center", // Center horizontally
                    "&:hover": {
                      borderColor: "#a0a0a0", // Darker grey on hover
                    },
                  }}
                >
                  <ArrowBackIosIcon
                    fontSize="small"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </Button>
                <GradientButtonOutline type="submit" onClick={handleNextStep}>
                  ดูตัวอย่าง
                </GradientButtonOutline>
                {/* <GradientButton
                  type="submit"
                  onClick={formik.handleSubmit}
                  style={{ marginRight: "20px" }}
                >
                  บันทึก
                </GradientButton> */}
                {/* <GradientButtonOutline type="submit" onClick={handleNextStep}>
                  ดูตัวอย่าง
                </GradientButtonOutline> */}
              </Grid>
            </Grid>
          </DialogActions>
        </>
      ) : (
        <>
          {/* Step 2: Confirmation Page */}
          <DialogTitle>
            <Typography variant="h4">ตัวอย่างแบบฟอร์มรายการคืน</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              {/* Left Side: PDF Preview (Scrollable) */}
              <Grid
                item
                xs={8}
                style={{
                  backgroundColor: "#f0f0f0",
                  padding: "20px",
                  height: "650px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                <Form data={formik.values} />
              </Grid>

              {/* Right Side: The Form or other content */}
              <Grid
                item
                xs={4}
                display={"flex"}
                flexDirection={"column"}
                style={{ padding: "20px" }}
              >
                <GradientShadow
                  isActive={activeButton === "pawnContract"}
                  onClick={() => handleButtonClick("pawnContract")}
                  style={{ margin: "10px" }}
                >
                  ใบเสร็จรับเงิน
                </GradientShadow>

                {/* <GradientShadow
                  isActive={activeButton === "saleRenewal"}
                  onClick={() => handleButtonClick("saleRenewal")}
                  style={{ margin: "10px" }}
                >
                  ใบขายฝาก / ต่ออายุ
                </GradientShadow> */}
                {/* Content for the right side */}
              </Grid>
            </Grid>
          </DialogContent>

          {/* <Divider style={{ marginTop: "0", marginBottom: "16px", mx: 2 }} /> */}

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              // backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <GradientButtonOutline
                  // GradientButtonOutlineon
                  onClick={handleBackToStep1}
                >
                  ยกเลิก
                </GradientButtonOutline>
                <Grid>
                  {isSuccess ? (
                    <>
                      <GradientButtonOutline
                        sx={{
                          width: "120px",
                          marginRight: "20px",
                        }}
                        endIcon={
                          <CheckCircle
                            sx={{
                              width: "16px",
                              height: "16px",
                            }}
                          />
                        }
                        id="btn-success"
                        onClick={handleClose}
                      >
                        เสร็จสิ้น
                      </GradientButtonOutline>
                      <GradientButton
                        id="btn-print-pdf"
                        onClick={handlePrintPDF}
                        sx={{ width: "100px" }}
                      >
                        พิมพ์
                      </GradientButton>
                    </>
                  ) : (
                    <>
                      <GradientButton
                        type="submit"
                        onClick={formik.handleSubmit}
                        style={{ marginRight: "20px", width: "150px" }}
                        disabled={loading}
                        endIcon={
                          loading ? (
                            <CircularProgress
                              color="inherit"
                              size={15}
                              thickness={5}
                            />
                          ) : null
                        }
                      >
                        บันทึก
                      </GradientButton>
                      <Tooltip
                        title={
                          <Typography
                            sx={{
                              fontSize: "14px",
                            }}
                          >
                            กรุณากดบันทึกก่อนพิมพ์
                          </Typography>
                        }
                        arrow={true}
                        placement="top"
                        disableHoverListener={isSuccess} // ปิด tooltip ถ้า isSuccess = true
                        disableFocusListener={isSuccess}
                      >
                        <span>
                          <GradientButtonOutline
                            disabled={!isSuccess}
                            sx={{
                              width: "100px",
                              border: "1px solid #ccc",
                            }}
                          >
                            พิมพ์
                          </GradientButtonOutline>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ModalReturn;
